import { LANDING_HEADER_NAVIGATION_HREF } from "../constants/app-constants";
import { getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";

export default function LevelTestSection({ props }) {
  const currentLanguage = getI18nLanguageFromLocalStorage();
  
  return (
    <div className="level-test-section relative overflow-hidden">
      <div className="level-test-title relative z-1">
        <h4 className="font-normal animate__animated animate__slideInLeft animate__delay-1s animate__slow">{props?.levelTestSectionTitle1}</h4>
        <div className="flex align-items-center gap-3">
          <h2 className="font-semibold animate__animated animate__slideInLeft animate__delay-1s animate__slow">{props?.levelTestSectionTitle2}</h2>
          <button onClick={() => (window.location.href = `/${currentLanguage}${LANDING_HEADER_NAVIGATION_HREF.PRE_TEST}`)}>
            <div className="level-test-icon animate__animated animate__rotateInDownLeft animate__delay-1s animate__slow">
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="21" viewBox="0 0 34 21" fill="none">
                <path
                  d="M0.5 10.8501C0.5 9.46942 1.61929 8.35013 3 8.35013H26C27.3807 8.35013 28.5 9.46942 28.5 10.8501C28.5 12.2308 27.3807 13.3501 26 13.3501H3C1.61929 13.3501 0.5 12.2308 0.5 10.8501Z"
                  fill="white"
                />
                <path
                  d="M33 11.7162C33.6667 11.3313 33.6667 10.369 33 9.9841L17.25 0.890838C16.5833 0.505937 15.75 0.987063 15.75 1.75686V19.9434C15.75 20.7132 16.5833 21.1943 17.25 20.8094L33 11.7162Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
      <div className="level-test-img absolute z-0">
        <img src={props?.levelTestSectionRightImage} alt="level-test-image" className="animate__animated animate__fadeInRight animate__delay-1s" />
      </div>
    </div>
  );
}
